import { render, staticRenderFns } from "./UPEINaOHStandardizationPreLab.vue?vue&type=template&id=85e8b66c&"
import script from "./UPEINaOHStandardizationPreLab.vue?vue&type=script&lang=js&"
export * from "./UPEINaOHStandardizationPreLab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
